import { render, staticRenderFns } from "./Proxmox.vue?vue&type=template&id=2b20d841&scoped=true"
import script from "./Proxmox.vue?vue&type=script&lang=js"
export * from "./Proxmox.vue?vue&type=script&lang=js"
import style0 from "./Proxmox.vue?vue&type=style&index=0&id=2b20d841&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20d841",
  null
  
)

export default component.exports